import {Injectable} from '@angular/core';
import {
  HttpRequest,
  HttpResponse,
  HttpHandler,
  HttpEvent,
  HttpInterceptor,
  HTTP_INTERCEPTORS
} from '@angular/common/http';
import {Observable, of, throwError} from 'rxjs';
import {delay, materialize, dematerialize} from 'rxjs/operators';
import {User} from "@app/models";

// array in local storage for registered users
const usersKey = 'angular-10-registration-login-example-users';
let users = JSON.parse(<string>localStorage.getItem(usersKey)) || [{username: 'test1', password: 'test1'}];

@Injectable()
export class FakeBackendInterceptor implements HttpInterceptor {
  intercept(request: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {
    const {url, method, headers, body} = request;

    return handleRoute();

    function handleRoute() {
      switch (true) {
        // case url.endsWith('/api/v1/users/') && method === 'GET':
        //   return getAllUsers();
      
        // case url.endsWith('/api/v1/users/') && method === 'POST':
        //   return createUser();

        case url.endsWith('/api/v1/services/') && method === 'GET':
          return getAllServices();
          
        case url.endsWith('/api/v1/notifications/') && method === 'GET':
          return getAllNotifications();
          
        case url.endsWith('/api/v1/moments/?page=1') && method === 'GET':
          return getAllMoments();

        case url.endsWith('/api/v1/moments/?page=2') && method === 'GET':
          return getAllMomentsP2();
          
        case url.endsWith('/api/v1/moments/?page=1&keyword=nic') && method === 'GET':
          return getAllMomentsP3();
          
        case url.endsWith('/api/v1/segmentations/?page=1') && method === 'GET':
          return getAllSegments();
         
        case url.endsWith('/api/v1/segmentations/?page=1&keyword=Asig') && method === 'GET':
          return getAllSegments();
          
        case url.endsWith('/api/v1/moments/') && method === 'POST':
          return createMoment();
          
        case url.endsWith('/api/v1/organizations/') && method === 'GET':
          return getAllOrganizations();
          
        case url.endsWith('/api/v1/organizations/') && method === 'POST':
          return createOrganization();
        
        case url.endsWith('/api/v1/typeorganizations/') && method === 'GET':
          return getTypeOrganizations();
        
        case url.endsWith('/api/v1/cities/') && method === 'GET':
          return getCities();
        
        case url.endsWith('/api/v1/accounts/id_type/') && method === 'GET':
          return getIdType();
        // case url.endsWith('/users/authenticate') && method === 'POST':
        //   return authenticate();
        case url.endsWith('/users/register') && method === 'POST':
          return register();
        case url.endsWith('/users') && method === 'GET':
          return getUsers();
        case url.match(/\/users\/\d+$/) && method === 'GET':
          return getUserById();
        case url.match(/\/users\/\d+$/) && method === 'PUT':
          return updateUser();
        case url.match(/\/users\/\d+$/) && method === 'DELETE':
          return deleteUser();
        default:
          // pass through any requests not handled above
          return next.handle(request);
      }
    }

    // route functions

    function authenticate() {
      const {username, password} = body;
      const user = users.find((x: any) => x.username === username && x.password === password);
      if (!user) return error('Username or password is incorrect');
      return ok({
        ...basicDetails(user),
        token: 'fake-jwt-token',
        refreshToken: 'fake-refresh-jwt-token',
        cookieEncrypt: 'cookie-encrypt'
      })
    }

    function register() {
      const user = body

      if (users.find((x: any) => x.username === user.username)) {
        return error('Username "' + user.username + '" is already taken')
      }

      user.id = users.length ? Math.max(...users.map((x: { id: any; }) => x.id)) + 1 : 1;
      users.push(user);
      localStorage.setItem(usersKey, JSON.stringify(users));
      return ok();
    }

    function getUsers() {
      if (!isLoggedIn()) return unauthorized();
      return ok(users.map((x: any) => basicDetails(x)));
    }

    function getUserById() {
      if (!isLoggedIn()) return unauthorized();

      const user = users.find((x: any) => x.id === idFromUrl());
      return ok(basicDetails(user));
    }

    function updateUser() {
      if (!isLoggedIn()) return unauthorized();

      let params = body;
      let user = users.find((x: any) => x.id === idFromUrl());

      // only update password if entered
      if (!params.password) {
        delete params.password;
      }

      // update and save user
      Object.assign(user, params);
      localStorage.setItem(usersKey, JSON.stringify(users));

      return ok();
    }

    function deleteUser() {
      if (!isLoggedIn()) return unauthorized();

      users = users.filter((x: any) => x.id !== idFromUrl());
      localStorage.setItem(usersKey, JSON.stringify(users));
      return ok();
    }

    // helper functions

    function ok(body?: any) {
      return of(new HttpResponse({status: 200, body}))
        .pipe(delay(500)); // delay observable to simulate server api call
    }

    function error(message: string) {
      return throwError({error: {message}})
        .pipe(materialize(), delay(500), dematerialize()); // call materialize and dematerialize to ensure delay even if an error is thrown (https://github.com/Reactive-Extensions/RxJS/issues/648);
    }

    function unauthorized() {
      return throwError(() => {
        return {status: 401, error: {message: 'Unauthorized'}}
      }).pipe(materialize(), delay(500), dematerialize());
      // return throwError({ status: 401, error: { message: 'Unauthorized' } })
      //     .pipe(materialize(), delay(500), dematerialize());
    }

    function basicDetails(user: any) {
      const {id, username, firstName, lastName} = user;
      return {id, username, firstName, lastName};
    }

    function isLoggedIn() {
      return headers.get('Authorization') === 'Bearer fake-jwt-token';
    }

    function idFromUrl() {
      const urlParts = url.split('/');
      return parseInt(urlParts[urlParts.length - 1]);
    }

    function getAllUsers() {

      return ok({
          data: [
            {
              'id': 1,
              'first_name': 'luis',
              'last_name': 'Rosero',
              'identify_type': 1,
              'indentify': '110123123',
              'username': 'luisito'
            },
            {
              'id': 2,
              'first_name': 'Armando',
              'last_name': 'Rosero',
              'identify_type': 1,
              'indentify': '1231251',
              'username': 'armando'
            }
          ],
          status: 'success'
        }
      );
    }
    function createUser() {

      return ok({
          data: {
              'id': 4,
              'first_name': 'Pepito',
              'last_name': 'Rosero',
              'identify_type': 1,
              'indentify': '110123123',
              'username': 'pepito22'
          },
          status: 'success'
        }
      );
    }

    function getAllServices() {

      return ok({
          data: [
            {
              'id': 1,
              'name': 'Momentos',
              'description': 'Momentos personalizados para la captura de información en campo',
              'url': 'moments'
            },
            {
              'id': 2,
              'name': 'Formularios',
              'description': 'Formularios personalizados para la captura de información en campo',
              'url': 'forms'
            }
          ],
          status: 'success'
        }
      );
    }

    function getAllNotifications() {

      return ok({
          data: [
            {
              'id': 1,
              'description': 'Lorem LIB, volutpat vitae tincidunt. Cursus morbi at mauris amet, ac sit convallis.',
              'date': 'Oct. 15'
            },
            {
              'id': 2,
              'description': 'Lorem AFK, volutpat vitae tincidunt. Cursus morbi at mauris amet, ac sit convallis.',
              'date': 'Sep. 30'
            }
          ],
          status: 'success'
        }
      );
    }

    function getAllMoments() {

      return ok({
          data: [
            {
              'id': 1,
              'name': 'Momento 1',
              'state': 0,
              'type': 'Tiempo',
              'obligatory': 0
            },
            {
              'id': 1,
              'name': 'Momento 2',
              'state': 1,
              'type': 'Unico',
              'obligatory': 0
            },
            {
              'id': 1,
              'name': 'Momento 3',
              'state': 0,
              'type': 'Repetición',
              'obligatory': 1
            },
          ],
          status: 'success',
          page_current: 1,
          page_size: 3,
          count: 5,
        }
      );
    }
    function getAllMomentsP2() {

      return ok({
          data: [
            {
              'id': 1,
              'name': 'Momento 4',
              'state': 1,
              'type': 'Tiempo',
              'obligatory': 0
            },
            {
              'id': 1,
              'name': 'Momento 5',
              'state': 1,
              'type': 'Unico',
              'obligatory': 1
            },
          ],
          page_current: 2,
          page_size: 3,
          count: 5,
        }
      );
    }

    function getAllMomentsP3() {

      return ok({
          data: [
            {
              'id': 1,
              'name': 'NIC 1',
              'state': 1,
              'type': 'Tiempo',
              'obligatory': 1
            },
            {
              'id': 1,
              'name': 'Danic',
              'state': 1,
              'type': 'Unico',
              'obligatory': 0
            },
          ],
          page_current: 1,
          page_size: 3,
          count: 2,
        }
      );
    }
    function getAllSegments() {

      return ok({
          results: [
            {id:1, name:"Asig 1", is_active: true, moment:'Momento 1', segmentation: 'Canal Directo'},
            {id:2, name:"Asig 2", is_active: false, moment:'Momento 2', segmentation: 'Todos los puntos'},
            {id:3, name:"Asig 3", is_active: true, moment:'Momento 3', segmentation: 'Superetes'},
          ],
          page_current: 1,
          page_size: 15,
          count: 3,
        }
      );
    }

    function createMoment() {

      return ok({
          data: {
            'id': 3,
            'name': 'Momento 3',
            'mod': 'Modalidad Prueba 4'
          },
          status: 'success'
        }
      );
    }

    function getAllOrganizations() {

      return ok({
          data: [
            {
              'id': 1,
              'name': 'Claro',
              'domain_url': 'claro.localhost',
              'schema_name': 'claro',
              'organization_id_type': 1,
              'organization_id_number': '1',
              'city': 1
            },
            {
              'id': 2,
              'name': 'Movistar',
              'domain_url': 'movistar.localhost',
              'schema_name': 'movistar',
              'organization_id_type': 1,
              'organization_id_number': '2',
              'city': 1
            },
            {
              'id': 3,
              'name': 'WOM',
              'domain_url': 'wom.localhost',
              'schema_name': 'wom',
              'organization_id_type': 1,
              'organization_id_number': '2',
              'city': 1
            }
          ],
          status: 'success'
        }
      );
    }

    function createOrganization() {

      return ok({
          data: {
            'id': 3,
            'name': 'ETB',
            'domain_url': 'etb.localhost',
            'schema_name': 'etb',
            'organization_id_type': 1,
            'organization_id_number': '2',
            'city': 1
          },
          status: 'success'
        }
      );
    }

    function getTypeOrganizations() {

      return ok({
          data: [
            {
              'id': 1,
              'name': 'Tipo 1',
            },
            {
              'id': 2,
              'name': 'Tipo 2',
            },
            {
              'id': 3,
              'name': 'Tipo 3',
            }
            
          ]
        }
      );
    }

    function getIdType() {

      return ok({
          data: [
            {
              'id': 1,
              'name': 'Cedula Ciudadania',
            },
            {
              'id': 2,
              'name': 'Nit',
            },
            {
              'id': 3,
              'name': 'Otro',
            }
            
          ]
        }
      );
    }

    function getCities() {

      return ok({
          data: [
            {
              'id': 1,
              'name': 'Cali',
            },
            {
              'id': 2,
              'name': 'Medellin',
            },
            {
              'id': 3,
              'name': 'Bogotá',
            }

          ]
        }
      );
    }

  }
}

export const fakeBackendProvider = {
  // use fake backend in place of Http service for backend-less development
  provide: HTTP_INTERCEPTORS,
  useClass: FakeBackendInterceptor,
  multi: true
};
